import React from 'react';
import { Section } from './Section';
import { XCircle } from 'lucide-react';
export function FailedAttempts() {
  const attempts = [{
    title: 'Los sprays y geles',
    desc: 'Matan la sensibilidad y destruyen el placer para ambos; a menudo terminas perdiendo la erección porque, simplemente, no sientes nada.'
  }, {
    title: 'La distracción mental',
    desc: 'Intentar no pensar en el sexo mientras lo tienes genera cortisol, la hormona del estrés, que irónicamente acelera la eyaculación.'
  }, {
    title: 'Los fármacos',
    desc: 'Tienen efectos secundarios que nublan tu mente y afectan tu salud cardiovascular a largo plazo para solucionar un problema de 10 minutos.'
  }, {
    title: 'Contar números o respirar mal',
    desc: 'Solo aumenta la ansiedad de desempeño, poniendo tu sistema nervioso en estado de alerta máxima.'
  }];
  return <Section darker data-id="element-29">
      <h2 className="font-display font-bold text-3xl md:text-5xl mb-12 text-center uppercase tracking-tight" data-id="element-30">
        Por qué lo que has intentado{' '}
        <span className="text-red-500" data-id="element-31">NO FUNCIONA</span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-32">
        {attempts.map((item, index) => <div key={index} className="bg-brand-gray/10 p-6 md:p-8 border border-brand-gray/30 flex flex-col" data-id="element-33">
            <div className="flex items-center mb-4" data-id="element-34">
              <XCircle className="text-red-500 w-8 h-8 mr-4 flex-shrink-0" data-id="element-35" />
              <h3 className="font-display font-bold text-xl md:text-2xl uppercase" data-id="element-36">
                {item.title}
              </h3>
            </div>
            <p className="text-gray-400 text-lg leading-relaxed" data-id="element-37">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}